import React from 'react';

export const PrimaryFormNav = ({prevLabel, nextLabel, handlePrevious, handleNext, options}) => (
	<div id="visitation-form-navigation">
		<button 
			className="previous-step" 
			onClick={(e) => {
				e.preventDefault();
				handlePrevious();
			}}>
			<img 
				src="/images/icons/blue-arrow-left.svg" 
				aria-hidden="true" 
				alt="" />
			<span>{prevLabel}</span>
		</button>
		<button 
			id="submit-form" 
			type="submit" 
			onClick={(e) => {
				e.preventDefault();
				handleNext(options);
			}}>
			<img 
				src="/images/icons/arrow-blue-background.svg" 
				aria-hidden="true" 
				alt="" />
			<span>{nextLabel}</span>
		</button>
	</div>
)



// WEBPACK FOOTER //
// ./src/components/PrimaryFormNav/PrimaryFormNav.js